import { ValidationItem } from 'src/types/ViewModel/ValidationItemType';
import { InputType } from '../OdfjellInputComponent';
import { prettifyHours } from 'odfjell-date-time-utils/dateTimeFormatter';
import { numberExists } from 'src/utils/propsUtils';

type Props = {
    isValid: boolean;
    type: InputType;
    selectedCustomValidation?: ValidationItem | null;
    min?: number;
    max?: number;
    unit?: string;
};

const ValidationComponent: React.FC<Props> = (props: Props) => {
    const getInputValidationText = () => {
        const min = props.type === 'time' ? prettifyHours(props.min) : props.min;
        const max = props.type === 'time' ? prettifyHours(props.max) : props.max;
        const unit = props.unit !== undefined ? props.unit : '';

        if (numberExists(props.min) && numberExists(props.max)) {
            return `The value must be between ${min} and ${max} ${unit}.`;
        }
        if (numberExists(props.min) && !numberExists(props.max)) {
            return `The value must be greater than ${min}${unit}.`;
        }
        if (!numberExists(props.min) && numberExists(props.max)) {
            return `The value must be less than ${max}${unit}.`;
        }
    };

    if (props.isValid) return <></>;

    if (props.selectedCustomValidation) {
        return (
            <div>
                <span>{props.selectedCustomValidation.errorMessage}</span>
            </div>
        );
    }

    return (
        <div>
            <span>{getInputValidationText()}</span>
        </div>
    );
};

export default ValidationComponent;
